// src/assets/icons/index.js

// 利用 require.context 自动导入目录下所有 .svg 文件
const req = require.context('./', false, /\.svg$/)
const requireAll = requireContext => requireContext.keys().map(requireContext)

requireAll(req)
